import { render, staticRenderFns } from "./ProdSquareSkuLogs.vue?vue&type=template&id=a8d9abf6&scoped=true&"
import script from "./ProdSquareSkuLogs.vue?vue&type=script&lang=js&"
export * from "./ProdSquareSkuLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d9abf6",
  null
  
)

export default component.exports